const LS_KEY_DEMO_MODE = "metrics-is-demo-mode";

export default {
  methods: {
    goToMetrics(path) {
      localStorage.removeItem(LS_KEY_DEMO_MODE);
      this.$router.push(path);
    },
  },
};
